//
//
//
//
//
//
//
//
//
//
//
//
//

import PageBtns from '@/components/common_pageBtns.vue'
export default {
  components: {PageBtns},
  data () {
    return {
      btnConfig: {
        absolute: true,
        list: [
          {text:'查看提现流水', type: 'primary', action: () => this.goWithdrawHistory()},
          {text:'继续提现', type: 'primary', action: () => this.goWithdraw()},
          {text:'返回',action: () => this.$router.go(-1)}
        ],
      }
    };
  },
  created(){
    this.getCashList()
  },

  computed: {
    nodeInfo () {
      return this.$store.state.nodeInfo
    },
  },

  methods: {
    goWithdrawHistory () {
      this.$router.push({
        path:"/mCc/nodeWalletHistory",
      })
    },
    go_back(){
      this.$router.go(-2)       
    },
    goWithdraw () {
      this.$router.push({
        path:"/mCc/nodeWalletWithdraw"
      })
    },

    getCashList () {
      this.$msg.loading()
      this.$http({
        url: this.$api.GetPassageNodeCashInOrderList,
        method: 'post',
      }).then(res => {
        this.$msg.hideLoading()
        if (res.data.state == 1) {
          this.$store.commit('set_nodeInfo', {totalMoney: res.data.totalMoney})
        }
      })
    },
  }
}

